import { axiosInstance } from "api/services/axiosInstance";
import { BUYERS_LITE_URL, BUYERS_URL } from "constants/ApiConstants";

const buyerApi = {
  getBuyersAPI: (searchParams, limit = 10, offset = 0) =>
    axiosInstance.get(`${BUYERS_URL}`, {
      params: { ...searchParams, offset, limit },
    }),
  getBuyersLiteAPI: (key) =>
    axiosInstance.get(`${BUYERS_LITE_URL}`, { params: { key } }),
};

export default buyerApi;
